import { Text } from '@timelyapp/react';
import React from 'react';
import { COLUMN_SIZE_MEDIUM } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import type { DatatableCellRenderer, DatatableColumnGetter } from './types';

export const getTextColumn: DatatableColumnGetter<
  string,
  { label: string; mandatory?: boolean; excludeAggregateView?: boolean }
> = (
  id: string,
  { label, mandatory, excludeAggregateView } = {
    label: '',
    mandatory: false,
    excludeAggregateView: false,
  }
) => ({
  id,
  header: props => <HeaderWithMenu {...props} label={label} sortLabelType="string" />,
  minSize: COLUMN_SIZE_MEDIUM,
  enableResizing: true,
  meta: {
    numeric: false,
    mandatory: mandatory,
    label: label,
    excludeAggregateView: excludeAggregateView,
  },
  cell: TextCell,
});

export const TextCell: DatatableCellRenderer<string> = ({ getValue }) => {
  const value = getValue() ?? '';
  return (
    <Text size="small" className="fs-mask">
      {value}
    </Text>
  );
};
